import { appStore, IEvent, MessageBus } from '@tom-ui/utils'
import { YardIssueResponse } from '@yard/app/api'
import { EventTypes } from '@yard/messages/eventsTypes'
import { yardIssueService } from '@yard/services/yard-issue.service'
import { makeObservable, observable, runInAction } from 'mobx'
import { YardIssueStatus, YardIssueWebSocketEvent } from '../models/yard-issue.model'

export type YardIssueItem = YardIssueResponse & { issueStatus?: YardIssueStatus }

export class YardIssueStore {
  items: YardIssueItem[] = []

  private readonly disposers: Array<() => void> = []

  constructor(private readonly messageBus: MessageBus) {
    makeObservable(this, {
      items: observable,
    })

    this.disposers.push(
      this.messageBus.subscribeEvent<YardIssueWebSocketEvent>(
        EventTypes.YardIssueUpsertedEvent,
        this.handleUpsertedEvent,
      ),
    )
  }

  dispose(): void {
    this.disposers.forEach(d => d())
    this.disposers.length = 0
  }

  async load() {
    try {
      const data = await yardIssueService.getYardIssues()
      runInAction(() => {
        this.items = data
      })
    } catch (e) {
      appStore.setShowAlert('error', (e as any)?.response?.data?.detail ?? 'An error occurred')
    }
  }

  private handleUpsertedEvent = (event: IEvent<YardIssueWebSocketEvent>) => {
    const response = event.payload
    if (!response) return

    const item: YardIssueItem = {
      ...response,
      containerIds: [],
    }

    runInAction(() => {
      const existingIndex = this.items.findIndex(i => i.issueId === item.issueId)
      if (existingIndex !== -1) {
        this.items = this.items.map((i, idx) => (idx === existingIndex ? item : i))
      } else {
        this.items = [...this.items, item]
      }
    })
  }
}
